import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import useAuth from '@/hooks/useAuth';
import useAxiosInterceptors from '@/hooks/useAxiosInterceptors';

const useLogout = (): UseMutationResult<void, Error, void, unknown> => {
  const queryclient = useQueryClient();
  const navigate = useNavigate();
  const { setToken, setClient } = useAuth();
  const axiosPrivate = useAxiosInterceptors();

  const logoutUser = useCallback(async () => {
    const response = await axiosPrivate.delete('/auth/logout');

    return response.data;
  }, [axiosPrivate]);

  const handleCleanUp = useCallback(() => {
    queryclient.clear();
    setToken(undefined);
    setClient(undefined);
    navigate('/login', { replace: true });
  }, [navigate, queryclient, setClient, setToken]);

  const logoutMutation = useMutation({
    mutationKey: ['logout'],
    mutationFn: logoutUser,
    onSuccess: () => {
      handleCleanUp();
    },
    onError: () => {
      handleCleanUp();
    },
  });

  return logoutMutation;
};

export default useLogout;
